import React, { useEffect, useState } from 'react';
import { Backdrop, Box, CircularProgress, Container, Paper, TextField, Typography } from '@mui/material';
import CustomHeader from '../../../core/components/common/custom-header.component';
import CustomButton from '../../../core/components/ui/CustomButton';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useOrg } from '../hooks/userOrg';
import OrganizationService from '../services/api/organization';
import { useSnackbar } from 'notistack';


export default function OrganizationUpdatePage() {

    const org_uid = new URLSearchParams(window.location.search).get("org_uid");

    const [org_name, setOrgName] = useState("");
    const [description, setDescription] = useState("");
    const [contact_email, setContactEmail] = useState("");
    const [contact_phone, setContactPhone] = useState("");
    const [orgErrors, setOrgErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const { enqueueSnackbar } = useSnackbar(); 

    const {updateOrg, isUpdating, viewOrg, orgDetails} = useOrg(); // Assuming you have a hook to handle organization updates

    const navigate = useNavigate();

    const handleChange = (setter, field) => (event) => {
        setter(event.target.value);
    };

    const handleBack = () => {
        navigate(-1); 
    }

    const handleSubmit = async () => {
        const orgErrors = {};
    
     
        
        setOrgErrors(orgErrors);
    
        if (Object.keys(orgErrors).length > 0) {
            return;
        }
    
        setLoading(true);
    
        try {
            
            const orgPayload = {
                org_uid,
                org_name: org_name ? org_name : orgDetails?.org_name,
                description: description ? description : orgDetails?.description,
                contact_email: contact_email ? contact_email : orgDetails?.contact_email,
                contact_phone: contact_phone ? contact_phone : orgDetails?.contact_phone,
            };
            
            const orgResponse = await OrganizationService.updateOrg(orgPayload);
            setSuccess(true);
            navigate('/organization')
            console.log('orgResponse orgResponse', orgResponse)

        } catch (error) {
            const errorMessage = error?.response?.data?.error || error?.response?.data?.error_message;
            console.log('errorMessage errorMessage', error)
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        } finally {
            setLoading(false);
        }
    };

    const validateContactEmailField = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setOrgErrors((prev) => ({
            ...prev,
            contact_email: value === ''
            ? ''
            : !emailRegex.test(value)
            ? 'Invalid email format'
            : '',
        }));
    };
    

    useEffect(()=>{ if(org_uid) viewOrg(org_uid) },[])

    return (
        <Box>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, }}
                open={loading}
            >
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                    <CircularProgress
                        color="inherit"
                        size={60}
                    />
                    <Typography mt={2} sx={{color:"#fff"}}>
                        Creating...
                    </Typography>
                </Box>
                
            </Backdrop>
            <CustomButton
                variant="text" 
                startIcon={<ArrowBackIcon fontSize="small" />}
                label="Back to Organization"
                customStyles={{fontSize: 14, mt: 2}}
                onClick={handleBack}
            />
            <Container maxWidth="md" sx={{mt: 5}}>
                <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                    <Box sx={{textAlign: "start", mb: 5}}>
                        <CustomHeader headerText={"Update Organization"} />
                    </Box>
                
                    <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField label="Organization Name" variant="standard" fullWidth
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }}
                            placeholder={orgDetails?.org_name}
                            // defaultValue={} 
                            onChange={handleChange(setOrgName)}
                            error={!!orgErrors.org_name}
                            helperText={orgErrors.org_name}
                        />
                        <TextField label="Description" multiline variant="standard" fullWidth
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }}
                            placeholder={orgDetails?.description} 
                            onChange={handleChange(setDescription)}
                            error={!!orgErrors.description}
                            helperText={orgErrors.description}
                        />

                        <TextField label="Contact Email" variant="standard" fullWidth
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }}
                            placeholder={orgDetails?.contact_email} 
                            onChange={(e) => {
                                const val = e.target.value;
                                setContactEmail(val);
                                validateContactEmailField(val);
                            }}
                            error={!!orgErrors.contact_email}
                            helperText={orgErrors.contact_email}
                        />
                        <TextField label="Contact Phone" variant="standard" type='number' fullWidth
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }}
                            placeholder={orgDetails?.contact_phone} 
                            onChange={handleChange(setContactPhone)}
                            error={!!orgErrors.contact_phone}
                            helperText={orgErrors.contact_phone}
                        />
                        <Box sx={{ textAlign:'end' }}>
                            <CustomButton
                                variant="contained" 
                                label="Update"
                                onClick={handleSubmit}
                                customStyles={{fontSize: 14, mb: 2}}
                            />
                        </Box>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
}